import React, { useState } from 'react';
import { useParams, Link } from 'react-router';
import { motion, AnimatePresence } from 'framer-motion';
import AnimacionPagina from '../componentes/AnimacionPagina';
import styled from 'styled-components';
import Header from '../componentes/Header';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import Footer from '../componentes/Footer';

import telasPremiumVeritlux from '../data/todosLosProductos/telasPremiumVertilux';

import {FichaProducto, Galeria, MotionImagen, Flecha, Miniaturas, Miniatura} from '../elementos/GaleriaStyles'

const DetallesVertilux = () => {
  const { slug } = useParams();
  const producto = telasPremiumVeritlux.find(
    p => p.slug === slug
  );

  const imagenInicial = producto?.images?.[0] || '';
  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
  const [animando, setAnimando] = useState(false);
  

  if (!producto) return <h2>Producto no encontrado</h2>;

  const imagenActual = producto.images[indiceSeleccionado];
  const imagenDeMuestra = producto.images[0];
  const imagenesDeColores = producto.images.slice(1);

  const cambiarImagen = (index) => {
    if (index >= 0 && index < producto.images.length) {
      setAnimando(true);
      setTimeout(() => {
        setIndiceSeleccionado(index);
        setAnimando(false);
      }, 50);
    }
  };

  return (
    <>
    <Header />
    <AnimacionPagina>
      <FichaProducto>
      <Galeria>
        <Flecha className='flechaBack' onClick={() => cambiarImagen(indiceSeleccionado - 1)}>&larr;</Flecha>
        <AnimatePresence mode="wait">
          <MotionImagen
            key={imagenActual}
            src={imagenActual}
            alt="Imagen seleccionada"
            initial={{ opacity: .5, scale: .5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
          />
        </AnimatePresence>
        <Flecha className='flechaSig' onClick={() => cambiarImagen(indiceSeleccionado + 1)}>&rarr;</Flecha>
      </Galeria>
      <Miniaturas> 
        <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.7 }}
        >
        <Miniatura
          activa={indiceSeleccionado === 0}
          onClick={() => cambiarImagen(0)}
        >
          <img src={imagenDeMuestra} alt="Muestra" />
          <span>Muestra</span>
        </Miniatura>
      </motion.div>
        
        {producto.colores.map((color, i) => (
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.7 }}
          >
          <Miniatura
            key={color}
            activa={indiceSeleccionado === i + 1}
            onClick={() => cambiarImagen(i + 1)}
          >
            <img src={imagenesDeColores[i]} alt={color} />
            <span>{color}</span>
          </Miniatura>
        </motion.div>
          
        ))}
      </Miniaturas>
      <h1>{producto.nombre}</h1>
            <h3>{producto.categoria}</h3>
               
          
            <br />
          
            <h4>Propiedades técnicas:</h4>
            <ul>
              <li><strong>Composición:</strong> {producto.composicion}</li>
              <li><strong>Peso:</strong> {producto.peso}</li>
              <li><strong>Grosor:</strong> {producto.grosor}</li>
              <li><strong>Tamaño de franja:</strong> {producto.tamanoFranja}</li>
              <li><strong>Ancho de rollo:</strong> {producto.anchoRollo}</li>
              <li><strong>Largo de rollo:</strong> {producto.largoRollo}</li>
              <li><strong>Resistencia a la tensión:</strong> {producto.resistenciaTension}</li>
              <li><strong>Elongación:</strong> {producto.elongacion}</li>
              <li><strong>Resistencia a la luz:</strong> {producto.resistenciaLuz}</li>
            </ul>
          
            <br />
          
            <h4>Propiedades de control solar:</h4>
            <ul>
              {producto.propiedadesControlSolar.map((prop, index) => (
                <li key={index}>{prop}</li>
              ))}
            </ul>
          
            <br />
          
            <h4>Cuidado y mantenimiento:</h4>
            <ul>
              {producto.cuidado.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          
            <br />
          
            <h4>Certificaciones:</h4>
            <ul>
              {producto.certificaciones.map((cert, index) => (
                <li key={index}>{cert}</li>
              ))}
            </ul>
          
            <br />
          
            <h4>Aplicaciones:</h4>
            <ul>
              {producto.aplicaciones.map((app, index) => (
                <li key={index}>{app}</li>
              ))}
            </ul>
          
            <br />
          
            <h4>Manufactura:</h4>
            <p>{producto.manufactura}</p>

     
          <BtnVolverAnim Ref='/telas-premium-vertilux'/>
          <WhatsAppShareButton message="¡Mira esta tela prémium!" />
      </FichaProducto>
      <Footer />
    </AnimacionPagina>
    </>
    
  );
};

export default DetallesVertilux;